import React, {useState} from 'react';
import Error from './Error'

const Pregunta = ({guardarPresupuesto, guardarRestante, actualizarPregunta}) => {

    //DEFINIR STATE
    const [cantidad, guardarCantidad] = useState(0);

    const  [error, guardarError] = useState(false);




    const definirPresupuesto= e =>{
       // e.preventDefault();

        guardarCantidad(parseInt(e.target.value,10))
        
    }

    //Submit para definir el PResupuesto
    const agregarPresupuesto=e =>{
        e.preventDefault();
      
      

        //Validar

        if (cantidad < 1 || isNaN(cantidad)) {
            guardarError(true);
          
            console.log("Hola");
            return;
            
        }

        //Si se pasa la validacion

        guardarError(false);
        guardarPresupuesto(cantidad);
        guardarRestante(cantidad);
        actualizarPregunta(false);
    

}
    
    return ( 
        <div>
            <h2>Coloca tu presupuesto</h2>
            {error ? <Error mensaje= "El Presupuesto es Incorrecto"
                        />
                
            
            :null}
            <form
                onSubmit={agregarPresupuesto}
            >
                <input
                    type="number"
                    className="u-full-width"
                    placeholder="Coloca tu presupuesto"
                    onChange={definirPresupuesto}
                />
                <input
                    type="submit"
                    className="button-primary u-full-width"
                    placeholder="Coloca tu presupuesto"
                    value="Definir Presupuesto"
                  
                />
            </form>
        </div>
     );
}
 
export default Pregunta;